__turbopack_context__.v({
  "content": "Content-module__XXZ-Lq__content",
});
